'use client';
import { Button } from '@ui/components/button';
import { Card } from '@ui/components/card';
import { Checkbox } from '@ui/components/checkbox';
import { Input } from '@ui/components/input';
import { Label } from '@ui/components/label';
import { text } from '@modules/garden-config/text';

import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faSparkles } from '@micks-yard/icons/solid/faSparkles';

interface BulkSowingActionsProps {
  selectedCount: number;
  bulkSeedBuffer: number;
  bulkIsActive: boolean;
  onBulkSeedBufferChange: (buffer: number) => void;
  onBulkIsActiveChange: (active: boolean) => void;
  onApply: (seedBuffer: number, isActive: boolean) => void;
  onClear: () => void;
}

export function BulkSowingActions({
  selectedCount,
  bulkSeedBuffer,
  bulkIsActive,
  onBulkSeedBufferChange,
  onBulkIsActiveChange,
  onApply,
  onClear,
}: BulkSowingActionsProps) {
  return (
    <Card className="mb-4 border-green-200 bg-green-50 p-4">
      <div className="mb-3 flex items-center gap-3">
        <FaIcon icon={faSparkles} className="size-5 text-green-600" />
        <h2 className="text-base font-semibold text-green-800">
          {text.bulkActionsTitle(selectedCount)}
        </h2>
      </div>

      <div className="flex flex-wrap items-end gap-2">
        <div className="flex w-32 flex-col gap-1">
          <Label className="text-muted-foreground">{text.seedBuffer}</Label>
          <Input
            className="h-7"
            inputMode="numeric"
            value={String(bulkSeedBuffer)}
            onChange={(event) => {
              const parsed = parseInt(event.target.value, 10);
              if (!isNaN(parsed) && parsed >= 0) {
                onBulkSeedBufferChange(parsed);
              }
            }}
          />
        </div>

        <div className="flex h-10 items-center gap-2">
          <Checkbox
            id="bulk-active"
            checked={bulkIsActive}
            onCheckedChange={(checked) => onBulkIsActiveChange(checked === true)}
          />
          <Label htmlFor="bulk-active" className="cursor-pointer">
            {text.active}
          </Label>
        </div>

        <Button onClick={() => onApply(bulkSeedBuffer, bulkIsActive)}>
          {text.applyToSelected}
        </Button>

        <Button variant="outline" onClick={onClear}>
          {text.clearSelection}
        </Button>
      </div>
    </Card>
  );
}
